export const FooterComponent = () => {
    return (
        <div className="text-center">
            <small className="font-10">
                {' '}
                COPYRIGHT © {new Date().getFullYear()} ALL RIGHTS RESERVED. MACS SOFTWARE CONSULTANCY{' '}
            </small>
        </div>
    );
};
